module.exports = __webpack_public_path__ + "static/media/ic_advise.7d0f8584.svg";